import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import esCommon from "./locales/es/common.json";
import enCommon from "./locales/en/common.json";
import esPublicReports from "./locales/es/publicReports.json";
import enPublicReports from "./locales/en/publicReports.json";
import esChat from "./locales/es/chat.json";
import enChat from "./locales/en/chat.json";
import esMiContenido from "./locales/es/miContenido.json";
import enMiContenido from "./locales/en/miContenido.json";
import esCampanas from "./locales/es/campanas.json";
import enCampanas from "./locales/en/campanas.json";
import esExplorar from "./locales/es/explorar.json";
import enExplorar from "./locales/en/explorar.json";
import esMediaKit from "./locales/es/mediaKit.json";
import enMediaKit from "./locales/en/mediaKit.json";
import esMetricsPdf from "./locales/es/metricsPdf.json";
import enMetricsPdf from "./locales/en/metricsPdf.json";
import esElecciones from "./locales/es/elecciones.json";
import enElecciones from "./locales/en/elecciones.json";
import esExplorer from "./locales/es/explorer.json";
import enExplorer from "./locales/en/explorer.json";

export const I18N_NAMESPACES = [
  "common",
  "publicReports",
  "chat",
  "miContenido",
  "campanas",
  "explorar",
  "mediaKit",
  "metricsPdf",
  "elecciones",
  "explorer",
] as const;

void i18n.use(initReactI18next).init({
  resources: {
    es: {
      common: esCommon,
      publicReports: esPublicReports,
      chat: esChat,
      miContenido: esMiContenido,
      campanas: esCampanas,
      explorar: esExplorar,
      mediaKit: esMediaKit,
      metricsPdf: esMetricsPdf,
      elecciones: esElecciones,
      explorer: esExplorer,
    },
    en: {
      common: enCommon,
      publicReports: enPublicReports,
      chat: enChat,
      miContenido: enMiContenido,
      campanas: enCampanas,
      explorar: enExplorar,
      mediaKit: enMediaKit,
      metricsPdf: enMetricsPdf,
      elecciones: enElecciones,
      explorer: enExplorer,
    },
  },
  lng: "es",
  fallbackLng: "es",
  ns: [...I18N_NAMESPACES],
  defaultNS: "common",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
